export default __webpack_public_path__ + "static/media/greek-wrestlers-wreath.f381c70e.svg";